/**
 * Response header the Consumer Portal API returns on every response, carrying
 * the id its log lines are written under (`reqId` in Sumo Logic). Lowercase
 * because axios, `fetch` and `getAllResponseHeaders` all report names that way.
 */
export const requestIdHeader = 'x-request-id';
